import React from 'react'
import { Box } from '@mui/system'

const LogoIcon = () => {
  return (
    <Box width='100%' sx={{height:63, alignContent:'center'}}>
      <img src={'./images/logo-icon.png'} alt="Aerosim" width="35px" />
    </Box>
  )
}

export default LogoIcon